// extracted by mini-css-extract-plugin
export default {"image":"I5zqsT"};